// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24wCp","controls":"styles_controls__93oOA","charLimit":"styles_charLimit__lQrhq","input":"styles_input__2IDQO","send":"styles_send__22UMj"};